<script setup lang="ts">
import Quote from '~/assets/icons/quote.svg?component'
const { company } = useCompany()
</script>

<template>
  <Container v-if="company.quote" class="screen-content px-2">
    <div class="content-company bg-main-50 bordershadow-lg-main mx-auto max-w-screen-sm rounded-lg px-8 !pb-8 !pt-6">
      <Quote width="42" class="text-main-950 mb-4 opacity-10" />

      <Paragraph size="medium" weight="normal" align="left" class="my-4">{{ company.quote.message }}</Paragraph>

      <div class="flex items-center justify-start gap-x-2">
        <NuxtImg
          src="/local/ceo.jpg"
          alt="Photo of our CEO, Maxim"
          width="64"
          height="64"
          format="webp"
          fit="cover"
          class="h-12 w-12 rounded-full"
        />

        <Paragraph size="normal" weight="medium">
          {{ `${company.quote.author}, ${company.quote.role}` }}
        </Paragraph>
      </div>
    </div>
  </Container>
</template>
